import { createRoutine } from 'redux-saga-routines';

import { IAsyncData } from '../../../models';
import { getInitialAsyncData } from '../../../utils';
import { IApplyForm } from '../components/Apply';
import { ECareersActions } from './enums';
import { applyPosition, getCareers as getCareersService } from './services';

export const getCareers = () => ({
    type: ECareersActions.GET_CAREERS,
    payload: getCareersService()
});

export const applyPositionAction = (form: IApplyForm) => ({
    type: ECareersActions.APPLY_POSITION,
    payload: applyPosition(form),
});

export const clearApplyPositionBranchAction = () => ({
    type: createRoutine(ECareersActions.APPLY_POSITION).TRIGGER,
    payload: getInitialAsyncData<IAsyncData<void>>(),
});
